import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from "formik";
import { SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { getConfiguration, putConfiguration } from 'store/thunks';
import * as Yup from "yup";


const Configuration = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const selectLayoutState = (state: any) => state.System;

  const SystemProperties = createSelector(
    selectLayoutState,
    (state) => ({
      configs: state.configs,
      isConfigSuccess: state.isConfigSuccess,
      isConfigLoading: state.isConfigLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { configs } = useSelector(SystemProperties);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (isLoading) {
      return;
    }
    setIsOpen((_prev) => true);
  };

  const handleSubmitConfiguration = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        configs: [
          {
            key: SYSTEM_CONFIG_KEY.AI_NEWS_GENERATION_ADD_NEXT,
            value: values?.add_next || '0',
            is_active: 1,
          },
        ]
      };

      const [res1]: any = await Promise.all([putConfiguration(_data_configs)]);
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (res1?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res1?.message || res1}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    add_next: Yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      add_next: '',

    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleCallAllOption = async () => {
    try {
      const [res1]: any = await Promise.all([getConfiguration({})]);
      const _configs = res1?.data?.list || [];
      const _config_add_next = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.AI_NEWS_GENERATION_ADD_NEXT) || {};

      formik?.setFieldValue('add_next', _config_add_next?.value);

    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Configuration')} - ${t('Real-time Keyword (User)')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Real-time Keyword (User)')} pageTitle={t('Configuration')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_AI_CUSTOM_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                  <CardBody className="pt-3">
                    <form onSubmit={formik.handleSubmit} style={{ maxWidth: '500px', margin: 'auto' }}>
                      {/* <Row>
                        <Col md={12} className="px-4 mt-4 mt-md-0">
                          <Row>
                            <div className="mb-3 position-relative" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                              <Col sm={12} md={12} xl={12} className='mt-2 pb-1'>
                                <Label htmlFor="add_next" className="form-label">{t('Items Next')}</Label> <span className="text-danger"> *</span>
                                <Input
                                  className="form-control"
                                  id="add_next"
                                  name="add_next"
                                  type="text"
                                  autoComplete='off'
                                  value={formik?.values?.add_next ?? ''}
                                  placeholder={t('Items Next')}
                                  onChange={(event: any) => {
                                    const input = event.target.value;
                                    const onlyNumbers = input.replace(/\D/g, "");
                                    const s = onlyNumbers;
                                    formik.setFieldValue("add_next", s);
                                  }}
                                />
                                {formik.touched.add_next && formik.errors.add_next ? (
                                  <div className="text-danger mt-2">{formik.errors.add_next}</div>
                                ) : null}
                              </Col>
                            </div>
                          </Row>
                        </Col>

                        <Col sm={12} md={12} xl={12} className='mt-1 pt-1 text-end'>
                          <button
                            style={{ width: '150px' }}
                            type="submit"
                            disabled={(isLoading)}
                            className="btn btn-primary fs-14 rounded-pill">
                            {<>{t('Button Update')}</>}
                          </button>
                        </Col>
                      </Row> */}
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Configuration')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default Configuration;

